import React, { Component } from 'react';
import {browserHistory} from "react-router";

class Sidemenu extends Component{
    constructor(props){
        super(props)
        this.state = {
            user:''
        
        }
        this.logout = this.logout.bind(this);
    }
    componentDidMount(){
        var user = localStorage.getItem("user");
        user = JSON.parse(user);
        if(user){
            console.log(user)
			this.setState({user:user});
		}
    }
    logout(){
        localStorage.removeItem('user');
        browserHistory.push("/");
    }
    render(){
        return(
        <div className="col s2 left-menu">
            {this.state.user_type !='' && this.state.user.user_type=='1' &&
            <ul>
                <li active><a href = "/token-list">
                <i class="small material-icons">confirmation_number</i> <span>Token List</span>
                </a></li>
                <li active><a href = "/coin-list">
                <i class="small material-icons">local_atm</i> <span>Coin List</span>
                </a></li>
                <li active><a href = "/nft-list">
                <i class="small material-icons">move_to_inbox</i> <span>NFT List</span>
                </a></li>
                <li active><a href = "/user-list">
                <i class="small material-icons">move_to_inbox</i> <span>User List</span>
                </a></li>
                <li><a onClick={this.logout} >
                <i class="small material-icons">settings_power</i> <span>Log out</span>
                </a></li>
            </ul>
             }
             {this.state.user_type !='' && this.state.user.user_type=='0' &&
            <ul>
                 <li><a href = "/newRecord">
                <i class="small material-icons">dvr</i> <span>Request Record</span>
                    </a></li>
                <li active><a href = "/token">
                <i class="small material-icons">confirmation_number</i> <span>Token</span>
                </a></li>
                <li active><a href = "/coin">
                <i class="small material-icons">local_atm</i> <span>Coin</span>
                </a></li>
                <li active><a href = "/nft">
                <i class="small material-icons">move_to_inbox</i> <span>NFT</span>
                </a></li>
                <li><a onClick={this.logout} >
                <i class="small material-icons">settings_power</i> <span>Log out</span>
                </a></li>
            </ul>
            }
        </div>
        );
    }

}
export default Sidemenu;